import React, { useCallback, useEffect } from 'react';

import { CenterCircularProgress } from '@europrocurement/flexy-components';
import { KeycloakRoute, REALM_INTERN } from '@europrocurement/l2d-keycloak';
import { Outlet } from 'react-router';

const RejectCodeRoot = function () {
    const loadInitialOptions = useCallback(() => {}, []);

    useEffect(() => {
        loadInitialOptions();
    }, [loadInitialOptions]);

    const isApplicationReady = () => true;

    return isApplicationReady() ? (
        <KeycloakRoute roles={REALM_INTERN}>
            <Outlet />
        </KeycloakRoute>
    ) : (
        <CenterCircularProgress />
    );
};

export default RejectCodeRoot;
